import { PaymentMethodCard } from '@vimond/services/default-payment-provider/types';
import { cn } from '@vimond/theme/tailwind';

type PaymentMethodCardComponentProps = {
  paymentMethod: PaymentMethodCard;
  onClick?: () => void;
  selected?: boolean;
};

const PaymentMethodCardComponent = ({
  onClick,
  paymentMethod,
  selected,
}: PaymentMethodCardComponentProps) => {
  return (
    <div
      className={cn(
        'bg-background-primary p-4 rounded-lg shadow-md w-[500px] relative box-border border-2 border-transparent transition-all ease-in',
        onClick && 'cursor-pointer hover:border-button-secondary-border',
        selected && 'border-white hover:border-white',
      )}
      onClick={onClick}
    >
      <div className="w-full grid grid-cols-[4fr_4fr_2fr]">
        <span className="text-lg font-bold text-text-primary flex items-center justify-start">
          {paymentMethod.brand.toUpperCase()}
        </span>
        <span className="text-md text-text-primary flex items-center justify-start">
          **** **** **** {paymentMethod.cardLast4}
        </span>
        <div className="text-md text-text-secondary flex items-center justify-end">
          {paymentMethod.cardExpiry}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodCardComponent;
